export const baseURL = "https://api.travelize.in";
// export const baseURL = "https://betaphase.in/travelizeapi";
